import { Mitarbeiter } from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import { Dayjs } from 'dayjs';

export class Krankmeldungen {
  constructor({
    istKindkrank,
    mitarbeiter,
    voraussichtlichVon,
    voraussichtlichBis,
  }: {
    istKindkrank: boolean;
    mitarbeiter: Mitarbeiter;
    voraussichtlichVon: Dayjs;
    voraussichtlichBis: Dayjs;
  }) {
    this.mitarbeiter = mitarbeiter;
    this.istKindkrank = istKindkrank;
    this.voraussichtlichVon = voraussichtlichVon;
    this.voraussichtlichBis = voraussichtlichBis;
  }

  istKindkrank: boolean;
  mitarbeiter: Mitarbeiter;
  voraussichtlichVon: Dayjs;
  voraussichtlichBis: Dayjs;
}
